import { useTranslation } from 'react-i18next';

export const useAddressGroupFieldTranslations = () => {
  const { t } = useTranslation('common');
  return {
    label: t('addressGroupField.label'),
    suiteLabel: t('addressGroupField.suiteLabel'),
    searchPlaceholder: t('addressGroupField.searchPlaceholder'),
    noSuggestionText: t('addressGroupField.noSuggestionText'),
    noSelectionText: t('addressGroupField.noSelectionText'),
    countryNotAllowedText: t('addressGroupField.countryNotAllowedText'),
    missingText: t('addressGroupField.missingText'),
    validationStreetText: t('addressGroupField.validationStreetText'),
    validationCityText: t('addressGroupField.validationCityText'),
    validationStateText: t('addressGroupField.validationStateText'),
    validationCountryText: t('addressGroupField.validationCountryText'),
    validationZipCodeText: t('addressGroupField.validationZipCodeText'),
    suiteHelperText: t('addressGroupField.suiteHelperText') || undefined,
  };
};
